(function () {
  if (customElements.get('variant-selects')) return;

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-product-variants]');
      if (!dataEl) return;

      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      this.idInput = this.querySelector('input[name="id"]');
      this.priceWrap = this.querySelector('.product__price-wrap');
      this.priceEl = this.querySelector('.product__price');
      this.stockEl = this.querySelector('[data-product-stock]');
      this.stockLabelEl = this.querySelector('[data-product-stock-label]');
      this.addToCartBtn = this.querySelector('.product__add-to-cart');
      this.optionFieldsets = this.querySelectorAll('.product__option');
      if (this.optionFieldsets.length === 0) return;

      this.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) this.onChange();
      });
    }

    onChange() {
      const selected = [];
      this.optionFieldsets.forEach((fs) => {
        const radio = fs.querySelector('input[type="radio"]:checked');
        selected.push(radio ? radio.value : null);
      });

      const variant = this.variants.find(
        (v) =>
          v.options.length === selected.length &&
          v.options.every((opt, i) => opt === selected[i])
      );

      if (!variant) return;

      if (this.idInput) this.idInput.value = variant.id;

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (err) {
        // ignore
      }

      this.optionFieldsets.forEach((fs) => {
        const radio = fs.querySelector('input[type="radio"]:checked');
        const span = fs.querySelector('.product__option-selected');
        if (span && radio) span.textContent = radio.value;
      });

      if (this.priceEl) this.priceEl.textContent = variant.price;

      if (this.priceWrap) {
        let compareEl = this.priceWrap.querySelector('.product__price-compare');
        if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
          if (!compareEl) {
            compareEl = document.createElement('s');
            compareEl.className = 'product__price-compare';
            // vor dem MwSt.-Hinweis einfügen, damit die Reihenfolge stimmt
            const taxNote = this.priceWrap.querySelector('.product__tax-note');
            if (taxNote) {
              this.priceWrap.insertBefore(compareEl, taxNote);
            } else {
              this.priceWrap.appendChild(compareEl);
            }
          }
          compareEl.textContent = variant.compare_at_price;
        } else if (compareEl) {
          compareEl.remove();
        }
      }

      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = !variant.available;
        const labelKey = variant.available ? 'textAvailable' : 'textSoldOut';
        const label = this.addToCartBtn.dataset[labelKey];
        if (label) this.addToCartBtn.textContent = label;
      }

      if (this.stockEl && variant.stock_state) {
        this.stockEl.classList.remove(
          'product__stock--in-stock',
          'product__stock--low',
          'product__stock--sold-out'
        );
        this.stockEl.classList.add('product__stock--' + variant.stock_state);
        if (this.stockLabelEl && variant.stock_label) {
          this.stockLabelEl.textContent = variant.stock_label;
        }
      }

      // Galerie über den Variantenwechsel informieren (Bilder filtern)
      this.dispatchEvent(
        new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } })
      );
    }
  }

  customElements.define('variant-selects', VariantSelects);
})();
